import Spinner from 'parkdepot-shared/components/Spinner'
import React, { FC, useEffect, useRef, useState } from 'react'

// types
import { IDropinContainerProps } from './types'

// hooks
import useAdyenSession from '../../hooks/useAdyenSession'

// components
import Dropin from './Dropin'

// queries

// style components
import { LoadingContainer } from './Dropin.style'

// utils
import { useGetUser } from '@hooks/useAuth'
import { useCheckoutSession, useUserCheckoutSession } from '@hooks/useBookingCheckoutSession'
import useLanguage from '@hooks/useLanguage.hook'
import { AdyenResultStatus } from '../../types/adyenResultStatus.enum'

const DropinContainer: FC<IDropinContainerProps> = ({
    orderId,
    loading,
    email,
    onCompleted,
    onError,
    onPaymentMethodChange
}) => {
    const user = useGetUser()
    const [session, setSession] = useState<{ [key: string]: string }>({})
    const [lng] = useLanguage()
    const dropInRef = useRef<null | HTMLDivElement>(null)
    const [dropin, setDropin] = useState<any>()
    const onPaymentCompleted = (resultCode: AdyenResultStatus) => {
        onCompleted(resultCode)
    }
    const onPaymentError = (error: any) => {
        onError(error)
    }
    const [createDropin, error] = useAdyenSession(session, onPaymentCompleted, onPaymentError)
    const useCheckoutHook = user ? useUserCheckoutSession : useCheckoutSession

    const { data, error: checkoutError } = useCheckoutHook(orderId, email, lng)

    useEffect(() => {
        if (data?.booking_create_adyen_session?.session_id && data?.booking_create_adyen_session?.session_data) {
            setSession({
                id: data.booking_create_adyen_session.session_id,
                sessionData: data.booking_create_adyen_session.session_data
            })
        }
    }, [data])

    useEffect(() => {
        if (checkoutError) {
            onError(checkoutError)
        }
    }, [checkoutError, onError])

    useEffect(() => {
        const initDropin = async () => {
            if (dropin) {
                setDropin(undefined)
            }
            const dropIn = await createDropin()
            setDropin(dropIn)
        }
        if (session?.id) {
            initDropin()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session])

    // a really hacky way to get the payment method...
    useEffect(() => {
        const handleClick = () => {
            if (dropin.activePaymentMethod) {
                setTimeout(() => {
                    onPaymentMethodChange(dropin.activePaymentMethod.type)
                }, 200)
            }
        }
        if (dropInRef && dropInRef.current) {
            dropInRef.current.addEventListener('click', handleClick)
        }
        return () => {
            dropInRef?.current?.removeEventListener('click', handleClick)
        }
    }, [dropin, onPaymentMethodChange])

    return (
        <>
            {!dropin || loading ? (
                <LoadingContainer>
                    <Spinner size="lg" theme="primary" />
                </LoadingContainer>
            ) : (
                <Dropin dropInRef={dropInRef} dropin={dropin} error={error} />
            )}
        </>
    )
}

export default DropinContainer
